import { CtResponse, zget, zhttp } from "../Fetch";
import { xget } from "../Fetchv2";
import { ses, ses_pages } from "../schemas/mg.schema";
import { PGSchema } from "../schemas/pg.schema.js";

export class SESAPI {
	async getSES(uid: string, params: any) {
		const r = await xget<{ ses_pages: ses_pages[]; ses: ses[] }>(`/users/${uid}/ses`, params);
		return r;
	}

	async createSES(uid: string, params: { token: string; name: string; lastname: string; email: string; phone: string; dpi: string; position: string; tags: string[] }) {
		const r = await zhttp(`/users/${uid}/ses`, "POST", params);
		return r;
	}

	async getUserSES(uid?: string, _id?: number, token?: string): Promise<CtResponse<ses>> {
		const r = await zget(`/users/${uid}/ses/${_id}`, { token });
		return r;
	}

	async adminGetSESPending(token: string, phase: string, limit?: number, skip?: number): Promise<CtResponse<ses[]>> {
		const r = await zget(`/ses`, { token, phase, limit, skip });
		return r;
	}

	async adminGetSES(cui?: string, token?: string) {
		const r = await zget<ses>(`/ses/${cui}`, { token });
		return r;
	}

	async adminEditSES(_id: PGSchema.users_ses["id"], data?: object): Promise<CtResponse<{ ok: number }>> {
		const r = await zhttp(`/ses/${_id}`, "PUT", data);
		return r;
	}

	// Gallery
	async getGallerySES(cui: string, ext: string = "jpg"): Promise<CtResponse<{ id: number; ext: string; public_url: string }[]>> {
		const r = await zget(`/ses/gallery/${cui}/${ext}`);
		return r;
	}

	async createGallerySES(cui: string, params: any, ext: string = "jpg"): Promise<CtResponse<{ id: number; ext: string; public_url: string }>> {
		const r = await zhttp(`/ses/gallery/${cui}/${ext}`, "POST", params);
		return r;
	}

	async deleteGallerySES(cui: string, id: any): Promise<CtResponse<{ id: number; ext: string; public_url: string }>> {
		const r = await zhttp(`/ses/gallery/${cui}/${id}`, "DELETE");
		return r;
	}
}
